module.exports = __webpack_public_path__ + "img/pwa-role-select.3fbe6c75.png";